import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Accordion } from 'react-accessible-accordion';
import { permissionTypes } from 'drapcode-constant';
import * as actions from '../../features/deployment-setting/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomLoader from '../common/CustomLoader';
import { AdvanceConfig, ItemDbConfig, MainConfig, ProjectDBConfig } from './';
import { checkCodeExportPermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';

export class CreateDeploymentSetting extends Component {
  static propTypes = {
    deploymentSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = { sameAsAbove: false };
  prepareValidationForFields = () => {
    let validationSchema = {
      name: Yup.string()
        .required("Setting Name can't be blank")
        .max(50, 'Setting Name can not be more than 50 characters')
        .matches(/^[A-Za-z\s]+$/, 'Setting Name should not contain special characters or numbers'),
    };
    return Yup.object().shape(validationSchema);
  };

  handleCheckboxChange = (event, values, setFieldValue) => {
    const {
      target: { name, value },
    } = event;
    let host = '',
      port = '',
      username = '',
      password = '';
    if (!this.state.sameAsAbove) {
      host = values.project.host;
      port = values.project.port;
      username = values.project.username;
      password = values.project.password;
    }
    setFieldValue('itemDB.host', host);
    setFieldValue('itemDB.port', port);
    setFieldValue('itemDB.username', username);
    setFieldValue('itemDB.password', password);
    this.setState((state) => ({ sameAsAbove: !state.sameAsAbove }));
  };

  handleFormSubmit = async (values) => {
    const { match, actions, history } = this.props;
    const { projectId, version } = match.params;
    await actions.createDeploymentSetting({ projectId, body: values, version });
    history.push(`/2.0/deployment-setting/${version}/v/${projectId}/`);
  };

  // upgradeAccountEmail = () => {
  //   const { actions, match } = this.props;
  //   const { projectId } = match.params;
  //   actions.requestUpgradeAccount({ projectId, code: permissionTypes.CODE_EXPORT });
  // };

  render() {
    const { deploymentSetting, common } = this.props;
    const { sameAsAbove } = this.state;
    const { createDeploymentSettingPending } = deploymentSetting;
    const { projectDetail } = common;
    if (!projectDetail) {
      return '';
    }
    const { domainName, projectType } = projectDetail;
    let domain = domainName;
    // let apiDomain = apiDomainName;

    const isAllowed = checkCodeExportPermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Code Export" />
        </CommonPageComponent>
      );
    }

    return (
      <CommonPageComponent>
        <ParentContentCard
          icon="deployment"
          title="Deployment Setting"
          headerTitle="Create Deployment Setting"
          headerText="Create"
          isSearch={false}
        >
          <Formik
            initialValues={{
              name: '',
              domainName: domain,
              faviconKeyName: '',
              projectLogoKeyName: '',
              project: {
                host: '127.0.0.1',
                port: '27017',
                username: '',
                password: '',
              },
              itemDB: {
                host: '127.0.0.1',
                port: '27017',
                username: '',
                password: '',
              },
            }}
            validationSchema={this.prepareValidationForFields()}
            onSubmit={(values, { setSubmitting }) => {
              this.handleFormSubmit(values);
              setSubmitting(false);
            }}
          >
            {({ isSubmitting, resetForm, setFieldValue, values }) => {
              return (
                <Form className="form-horizontal">
                  <div className="row mx-auto">
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                      <Accordion
                        allowMultipleExpanded={true}
                        allowZeroExpanded={true}
                        preExpanded={['main-config']}
                      >
                        <MainConfig />
                        <ProjectDBConfig />
                        <ItemDbConfig
                          sameAsAbove={sameAsAbove}
                          values={values}
                          setFieldValue={setFieldValue}
                          handleCheckboxChange={this.handleCheckboxChange}
                        />
                        <AdvanceConfig />
                      </Accordion>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between align-items-center">
                    <button
                      className="btn btn-outline-secondary btn-sm"
                      title="Cancel"
                      onClick={resetForm}
                      type="reset"
                    >
                      <i className="wb webconnect-times"></i> Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-theme-submit btn-sm"
                      title="Save Collection"
                      disabled={createDeploymentSettingPending}
                    >
                      <i className="wb webconnect-save-regular"></i> Save
                      <CustomLoader loading={createDeploymentSettingPending}></CustomLoader>
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    deploymentSetting: state.deploymentSetting,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateDeploymentSetting);
